/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __extends } from "tslib";
import { EventDispatcher } from '../events/EventDispatcher';
import { notImplemented, release } from '@awayfl/swf-loader';
// Class: GameInputControl
var GameInputControl = /** @class */ (function (_super) {
    __extends(GameInputControl, _super);
    function GameInputControl() {
        return _super.call(this) || this;
    }
    Object.defineProperty(GameInputControl.prototype, "numValues", {
        // _numValues: number /*int*/;
        // _index: number /*int*/;
        // _relative: boolean;
        // _type: string;
        // _hand: string;
        // _finger: string;
        // _device: flash.ui.GameInputDevice;
        get: function () {
            release || notImplemented('public flash.ui.GameInputControl::get numValues');
            return;
            // return this._numValues;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputControl.prototype, "index", {
        get: function () {
            release || notImplemented('public flash.ui.GameInputControl::get index');
            return;
            // return this._index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputControl.prototype, "relative", {
        get: function () {
            release || notImplemented('public flash.ui.GameInputControl::get relative');
            return;
            // return this._relative;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputControl.prototype, "type", {
        get: function () {
            release || notImplemented('public flash.ui.GameInputControl::get type');
            return;
            // return this._type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputControl.prototype, "hand", {
        get: function () {
            release || notImplemented('public flash.ui.GameInputControl::get hand');
            return;
            // return this._hand;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputControl.prototype, "finger", {
        get: function () {
            release || notImplemented('public flash.ui.GameInputControl::get finger');
            return;
            // return this._finger;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputControl.prototype, "device", {
        get: function () {
            release || notImplemented('public flash.ui.GameInputControl::get device');
            return;
            // return this._device;
        },
        enumerable: true,
        configurable: true
    });
    GameInputControl.prototype.getValueAt = function (index) {
        if (index === void 0) { index = 0; }
        index = index | 0;
        release || notImplemented('public flash.ui.GameInputControl::getValueAt');
        return;
    };
    // Called whenever the class is initialized.
    GameInputControl.classInitializer = null;
    // List of static symbols to link.
    GameInputControl.classSymbols = null; // [];
    // List of instance symbols to link.
    GameInputControl.instanceSymbols = null; // [];
    return GameInputControl;
}(EventDispatcher));
export { GameInputControl };
